import { MarginExpenseType } from '../../models/margin-expense-type.model';
import { MarginExpense } from '../../models/margin-expenses.model';

export interface MarginExpensesSlice {
    marginExpenses: MarginExpense[];
    marginExpenseTypes: MarginExpenseType[];
}

export const initialMarginExpensesSlice: MarginExpensesSlice = {
    marginExpenses: [],
    marginExpenseTypes: []
};
